export default __webpack_public_path__ + "static/media/audio_03_barco_pirata.dacb2fd2.mp3";